import React, { useState } from 'react';
import { useFormHorarioClienteContext } from './Context';
import MultiSelect from '../../../../components/inputs/MultiSelect';
import { UserService } from '../../../configuracoes/usuario/Service';
import { baseURL } from '../../../../AxiosConfig';
import { Check } from 'lucide-react';
const userService = new UserService();

const getInitials = (name?: string) => {
    const parts = String(name || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2);

    if (!parts.length) return '?';

    return parts.map((part) => part[0]?.toUpperCase()).join('');
};

const getContactText = (option: any) => {
    const contact = [option?.email, option?.phoneNumber]
        .map((item) => String(item || '').trim())
        .filter(Boolean);

    return contact.join(' • ');
};

const ClientOptionLabel = ({
    option,
    context,
    selected,
}: {
    option: any;
    context: 'menu' | 'value';
    selected: boolean;
}) => {
    const [imageError, setImageError] = useState(false);
    const initials = getInitials(option?.label);
    const imageUrl = `${baseURL}/users/profileImage/${option?.value}`;
    const contactText = getContactText(option);

    if (context === 'value') {
        return (
            <div className="flex min-w-0 items-center gap-2">
                <div className="flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/15 text-[10px] font-bold text-primary">
                    {!imageError ? (
                        <img
                            src={imageUrl}
                            alt=""
                            className="h-full w-full object-cover"
                            onError={() => setImageError(true)}
                        />
                    ) : (
                        initials
                    )}
                </div>
                <span className="truncate">{option.label}</span>
            </div>
        );
    }

    return (
        <div
            className={`flex min-w-0 items-center gap-3 rounded-xl px-2.5 py-2 transition-all duration-150 hover:bg-primary/10 ${
                selected ? 'bg-primary/10' : ''
            }`}
        >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/15 text-xs font-bold text-primary ring-1 ring-primary/20">
                {!imageError ? (
                    <img
                        src={imageUrl}
                        alt=""
                        className="h-full w-full object-cover"
                        onError={() => setImageError(true)}
                    />
                ) : (
                    initials
                )}
            </div>
            <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-semibold text-base-content">
                    {option.label}
                </div>
                <div className="truncate text-[11px] font-medium text-base-content/50">
                    {contactText || 'Sem email ou telefone'}
                </div>
            </div>
            {selected && (
                <Check className="text-xs text-primary" aria-hidden="true" />
            )}
        </div>
    );
};

const SelectClient = () => {
    const { clientId, setClientId, clients, setClients, loading, setLoading, lockCliente } = useFormHorarioClienteContext();
    const [inputValue, setInputValue] = useState('');

    const handleCreateClient = async (inputValue: string) => {
        setLoading(true);
        const { data } = await userService.createClient({ name: inputValue });
        setLoading(false);

        const newOption = {
            value: data.uid,
            label: inputValue,
            email: data.email,
            phoneNumber: data.phoneNumber,
        };
        setClients((prev: any) => [...prev, newOption]);
        setClientId(data.uid);
    };

    let filteredOptions = clients
        .filter(c => c.label.toLowerCase().includes(inputValue.toLowerCase()))
        .slice(0, 10);

    if (clientId && !filteredOptions.some(c => c.value === clientId)) {
        const selectedClient = clients.find(c => c.value === clientId);
        if (selectedClient) {
            filteredOptions = [selectedClient, ...filteredOptions];
        }
    }

    return (
        <MultiSelect
            options={filteredOptions}
            loading={loading}
            disabled={lockCliente}
            value={clientId}
            onChange={(selected) => setClientId(selected as string)}
            onCreateOption={lockCliente ? undefined : handleCreateClient}
            placeholder="Selecione o cliente"
            formatOptionLabel={(option: any, meta: any) => (
                <ClientOptionLabel
                    option={option}
                    context={meta.context}
                    selected={clientId === option.value}
                />
            )}
            label="Cliente"
            name="cliente"
            multiple={false}
            menuOverlay
            onInputChange={(value: any) => setInputValue(value)}
        />
    );
};

export default SelectClient;
